import type { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { ErrorModalService } from './ErrorModal.service';
import { LogoutService } from '@core/auth/Logout.service';
import { HttpCancelService } from './abort-ongoing-requests/HttpCancel.service';
import { ToasterService } from '@core/services/toaster.service';

export const httpErrorHandlingInterceptor: HttpInterceptorFn = (req, next) => {
  const _ErrorModalService = inject(ErrorModalService);
  const _LogoutService = inject(LogoutService);
  const _HttpCancelService = inject(HttpCancelService);
  const _toasterService = inject(ToasterService);


  return next(req).pipe(
    tap({
      error: (err: HttpErrorResponse) => {
        if (err.status == 401) {

          _HttpCancelService.cancelRequests();

          _ErrorModalService.showError({
            title: 'Session Expired',
            msg: err.error.message || err.message,
            autoClose: true,
            autoCloseAfterSec: 5
          }).subscribe(() => {
            _LogoutService.logout(true);
          });
        } else {
          // _ErrorModalService.showError({
          //   title: 'Error',
          //   msg: err.error.message || err.message,
          // }).subscribe();
          _toasterService.showError(err.error.message || err.message, 'Error');
        }
      },
    })
  );
};
